/**
 * Created by Angelika on 01.09.2017.
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import PropTypes from 'prop-types';
import * as AppContentActions from '../actions/appContent';
import ChannelList from './ChannelList';
import GenreList from "./GenreList";

const filterItems = (genre, items) => {
    if (genre && genre.id !== "") {
        return items.filter(item => item.genreId === genre.id);
    } else {
        return items;
    }
};

class ChannelFrame extends Component {

    componentDidMount() {
        const {appContentActions} = this.props;
        appContentActions.showChannelFrame();
    }

    channelsEmpty() {
        const {activeGenre} = this.props;
        return (
            activeGenre && <div className="channel-list-container">
                <div className="genre-name">{activeGenre.title}</div>
                <ChannelList items={null} />
            </div>
        );
    }

    isFavoriteSelected() {
        const {activeGenre} = this.props;
        return activeGenre && activeGenre.id === 'favorite';
    }

    channelListContainer(item, index) {
        let isFavoriteItem = (item.genreId === 'favorite');
        if (isFavoriteItem && !this.isFavoriteSelected()) {
            return null;
        } else {
            return (
                <div key={index} className="channel-list-container">
                    <div className="genre-name">{item.genreName}</div>
                    <ChannelList items={item.channels}/>
                </div>
            )
        }
    }

    render() {
        const {items} = this.props;
        return (
            <section id="channel-frame">
                {items.length === 0
                    ? this.channelsEmpty()
                    : items.map((item, index) => this.channelListContainer(item, index))
                }
            </section>
        )
    }
}

ChannelFrame.propTypes = {
    activeGenre: PropTypes.object,
    items: PropTypes.array.isRequired,
    appContentActions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        activeGenre: state.genres.activeGenre,
        items: filterItems(state.genres.activeGenre, state.channels.formattedChannels)
    }
};

const mapDispatchToProps = dispatch => {
    return {
        appContentActions: bindActionCreators(AppContentActions, dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChannelFrame);



// WEBPACK FOOTER //
// ./src/containers/ChannelFrame.js